import React, { useEffect, useState } from "react";
import "../../components/DashboardModule/TrackingOrder.css";
import { FaCheckCircle, FaCog, FaTruck, FaBoxOpen } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { getQuotationTrackingLogs } from "../../API/Api";

const TrackingOrder = ({ orderId, quotationId, onClose }) => {
	const [trackingData, setTrackingData] = useState([]);
	const [loading, setLoading] = useState(true);

	const statusIcons = {
		"Confirmed": <FaCheckCircle />,
		"Manufacturing": <FaCog />,
		"Inspection": <FaCheckCircle />,
		"Dispatched": <FaTruck />,
		"Delivered": <FaBoxOpen />
	};

	useEffect(() => {
		const fetchTrackingLogs = async () => {
			try {
				const res = await getQuotationTrackingLogs(quotationId);
				if (res?.status && res.data?.length) {
					const transformedData = res.data.map(log => ({
						status: log.status,
						time: log.formatted_date,
						icon: statusIcons[log.status] || <FaCheckCircle />,
						updatedBy: log.user?.display_name || "System"
					}));

					setTrackingData(transformedData);
				}
			} catch (err) {
				console.error("Failed to fetch tracking logs:", err);
			} finally {
				setLoading(false);
			}
		};

		if (quotationId) {
			fetchTrackingLogs();
		}
	}, [quotationId]);

	return (
		<div className="tracking-order-container">
			<div className="tracking-header">
				<span className="tracking-title-text">Order Tracking Status</span>
				<button className="close-icon-btn" onClick={onClose}>
					<IoClose />
				</button>
			</div>
			<div className="tracking-content">
				{loading ? (
					<div className="tracking-loading">Loading tracking data...</div>
				) : trackingData.length > 0 ? (
					<div className="tracking-timeline">
						{trackingData.map((item, index) => (
							<div className="tracking-step" key={index}>
								<div className="tracking-icon">{item.icon}</div>
								<div className="tracking-info">
									<div className="tracking-title">
										{item.status}
										<span className="tracking-time">{item.time}</span>
									</div>
									<div className="tracking-updated">Updated by: {item.updatedBy}</div>
								</div>
							</div>
						))}
					</div>
				) : (
					<div className="tracking-empty">No tracking data available</div>
				)}
			</div>
		</div>
	);
};

export default TrackingOrder;










// import React, { useEffect, useState } from "react";
// import "../../components/DashboardModule/TrackingOrder.css";
// import { FaCheckCircle, FaCog, FaEnvelope, FaTruck, FaBoxOpen } from "react-icons/fa";
// import { IoClose } from "react-icons/io5";
// import { getQuotationTrackingLogs } from "../../API/Api";

// // Map API status to icons
// const statusIcons = {
// 	"Confirmed": <FaCheckCircle />,
// 	"Manufacturing": <FaCog />,
// 	"Dispatched": <FaTruck />,
// 	"Delivered": <FaBoxOpen />,
// 	"default": <FaEnvelope />
// };

// const TrackingOrder = ({ onClose, quotation_id }) => {
// 	const [trackingData, setTrackingData] = useState([]);
// 	const [loading, setLoading] = useState(true);
// 	const [error, setError] = useState(null);

// 	useEffect(() => {
// 		const fetchTrackingLogs = async () => {
// 			try {
// 				setLoading(true);
// 				const res = await getQuotationTrackingLogs(quotation_id);

// 				if (res?.status && res?.data?.length) {
// 					// Transform API data to match UI structure
// 					const transformedData = res.data.map(item => ({
// 						status: item.status,
// 						time: item.formatted_date,
// 						icon: statusIcons[item.status] || statusIcons.default,
// 						updatedBy: item.user?.display_name || "System"
// 					}));

// 					setTrackingData(transformedData);
// 				} else {
// 					setTrackingData([]);
// 				}
// 			} catch (err) {
// 				console.error("Failed to fetch tracking logs:", err);
// 				setError("Failed to load tracking data");
// 			} finally {
// 				setLoading(false);
// 			}
// 		};

// 		if (quotation_id) {
// 			fetchTrackingLogs();
// 		}
// 	}, [quotation_id]);

// 	if (loading) {
// 		return (
// 			<div className="tracking-order-container">
// 				<div className="tracking-header">
// 					<span className="tracking-title-text">Order Tracking Status</span>
// 					<button className="close-icon-btn" onClick={onClose}>
// 						<IoClose />
// 					</button>
// 				</div>
// 				<div className="loading-message">Loading tracking information...</div>
// 			</div>
// 		);
// 	}

// 	if (error) {
// 		return (
// 			<div className="tracking-order-container">
// 				<div className="tracking-header">
// 					<span className="tracking-title-text">Order Tracking Status</span>
// 					<button className="close-icon-btn" onClick={onClose}>
// 						<IoClose />
// 					</button>
// 				</div>
// 				<div className="error-message">{error}</div>
// 			</div>
// 		);
// 	}

// 	return (
// 		<div className="tracking-order-container">
// 			<div className="tracking-header">
// 				<span className="tracking-title-text">Order Tracking Status</span>
// 				<button className="close-icon-btn" onClick={onClose}>
// 					<IoClose />
// 				</button>
// 			</div>
// 			<div className="tracking-content">
// 				<h3 className="quotation-number">Quotation #{quotation_id}</h3>
// 				{trackingData.length > 0 ? (
// 					<div className="tracking-timeline">
// 						{trackingData.map((item, index) => (
// 							<div className="tracking-step" key={index}>
// 								<div className="tracking-icon">{item.icon}</div>
// 								<div className="tracking-info">
// 									<div className="tracking-title">
// 										{item.status}
// 										<span className="tracking-time">{item.time}</span>
// 									</div>
// 									<div className="tracking-updated">Updated by: {item.updatedBy}</div>
// 								</div>
// 							</div>
// 						))}
// 					</div>
// 				) : (
// 					<div className="no-data-message">No tracking data available</div>
// 				)}
// 			</div>
// 		</div>
// 	);
// };

// export default TrackingOrder;